import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Modal, Form, Button, Header } from 'semantic-ui-react';

const GoalSettings = observer(({ companyStore, open, onClose }) => {
    const goals = companyStore?.company?.practiceGoals;
    const [weeklyTarget, setWeeklyTarget] = useState(goals?.weeklyTarget || 0);
    const [monthlyTarget, setMonthlyTarget] = useState(goals?.monthlyTarget || 0);
    const [saving, setSaving] = useState(false);

    React.useEffect(() => {
        if (open) {
            setWeeklyTarget(goals?.weeklyTarget || 0);
            setMonthlyTarget(goals?.monthlyTarget || 0);
        }
    }, [open, goals?.weeklyTarget, goals?.monthlyTarget]);

    const handleSave = async () => {
        setSaving(true);
        try {
            await companyStore.company.updateFromSnapshot({
                practiceGoals: {
                    weeklyTarget: Number(weeklyTarget) || 0,
                    monthlyTarget: Number(monthlyTarget) || 0,
                }
            });
            onClose();
        } catch (err) {
            console.error('Failed to save practice goals:', err);
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal open={open} onClose={onClose} size="small" closeIcon>
            <Header icon="target" content="Practice Goals" style={{ fontFamily: 'Montserrat' }} />
            <Modal.Content>
                <p style={{ fontFamily: 'Montserrat', fontSize: '14px', color: '#666', marginBottom: '20px' }}>
                    Set practice targets for your team. These goals will be visible to all team members on their dashboard.
                </p>
                <Form>
                    <Form.Field>
                        <label style={{ fontFamily: 'Montserrat' }}>Weekly Practice Target</label>
                        <Form.Input
                            type="number"
                            min="0"
                            max="50"
                            value={weeklyTarget}
                            onChange={(e) => setWeeklyTarget(e.target.value)}
                            placeholder="e.g., 3 practices per week"
                        />
                    </Form.Field>
                    <Form.Field>
                        <label style={{ fontFamily: 'Montserrat' }}>Monthly Practice Target</label>
                        <Form.Input
                            type="number"
                            min="0"
                            max="200"
                            value={monthlyTarget}
                            onChange={(e) => setMonthlyTarget(e.target.value)}
                            placeholder="e.g., 12 practices per month"
                        />
                    </Form.Field>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={onClose} style={{ fontFamily: 'Montserrat' }}>Cancel</Button>
                <Button
                    primary
                    loading={saving}
                    onClick={handleSave}
                    style={{ fontFamily: 'Montserrat', backgroundColor: '#137fa2' }}
                >
                    Save Goals
                </Button>
            </Modal.Actions>
        </Modal>
    );
});

export default GoalSettings;
